(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('suntrybe-product-info')) {
    customElements.define('suntrybe-product-info', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.organized) return;
        const source = this.querySelector('[data-product-info-source] .text-block');
        if (!source) return;
        const pieces = [];
        let line = document.createDocumentFragment();
        const flush = () => {
          if (line.textContent.trim() || line.querySelector('img, video, iframe')) {
            const paragraph = document.createElement('p');
            paragraph.append(line);
            pieces.push(paragraph);
          }
          line = document.createDocumentFragment();
        };
        const walk = (node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            line.append(node.cloneNode(true));
            return;
          }
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          const tag = node.tagName;
          if (tag === 'BR') { flush(); return; }
          if (['DIV', 'SECTION', 'P'].includes(tag)) {
            flush();
            Array.from(node.childNodes).forEach(walk);
            flush();
            return;
          }
          if (/^H[1-6]$/.test(tag) || ['UL', 'OL', 'TABLE', 'DETAILS', 'FIGURE'].includes(tag)) {
            flush();
            pieces.push(node.cloneNode(true));
            return;
          }
          line.append(node.cloneNode(true));
        };
        Array.from(source.childNodes).forEach(walk);
        flush();
        const groups = { description: [], details: [], care: [], size: [] };
        let group = 'description';
        for (const piece of pieces) {
          const text = piece.textContent.trim();
          const normalized = text.replace(/[:：]+$/, '').trim().toLowerCase();
          if (/^(product features|product details|key features|features|details|materials|fabric|fit)$/.test(normalized)) {
            group = 'details';
            if (!/^(product features|product details|key features|features|details)$/.test(normalized)) groups[group].push(piece);
            continue;
          }
          if (/^(care instructions|washing instructions|care|wash care)$/.test(normalized)) { group = 'care'; continue; }
          if (/^(size chart|size guide|sizing|measurements)$/.test(normalized)) { group = 'size'; continue; }
          if (piece.tagName === 'TABLE') {
            const isSize = piece.id === 'size-guide' || /\b(size|width|length|chest|tolerance|thickness)\b/i.test(text);
            groups[isSize ? 'size' : 'details'].push(piece);
            continue;
          }
          if (/^(care|care instructions|washing instructions)\s*:/i.test(text)) group = 'care';
          else if (group === 'description' && (/^H[1-6]$/.test(piece.tagName) || ['UL', 'OL'].includes(piece.tagName) || /^(fabric|materials|product features|product details)\s*:/i.test(text))) group = 'details';
          groups[group].push(piece);
        }

        const careSymbols = [
          { match: /\b(wash|washing|clean with|spot clean|spotclean)\b/i, prohibit: /(?:do not|don't|no|avoid)\s+(?:machine\s+)?wash/i, shape: '<path d="M3 7l2 13h14l2-13M4 11c2-3 4 3 6 0s4 3 6 0 3 0 4 0"/>' },
          { match: /bleach/i, prohibit: /(?:do not|don't|no|avoid)\s+(?:use\s+)?bleach/i, shape: '<path d="M12 3L2 21h20L12 3z"/>' },
          { match: /tumble|tumbling|dryer|drying/i, prohibit: /(?:do not|don't|no|avoid)\s+(?:use\s+)?(?:tumble|tumbling|dryer)/i, shape: '<rect x="3" y="3" width="18" height="18" rx="1"/><circle cx="12" cy="12" r="6"/>' },
          { match: /\biron(?:ing)?\b/i, prohibit: /(?:do not|don't|no|avoid)\s+iron/i, shape: '<path d="M3 18h18l-3-9H9c-3 0-5 4-6 9zM10 9V6h6l2 3"/>' },
          { match: /dry[ -]?clean/i, prohibit: /(?:do not|don't|no|avoid)\s+dry[ -]?clean/i, shape: '<circle cx="12" cy="12" r="9"/>' }
        ];
        for (const piece of groups.care) {
          const items = piece.matches('ul, ol') ? Array.from(piece.querySelectorAll('li')) : piece.matches('p') ? [piece] : [];
          let decorated = false;
          for (const item of items) {
            const instruction = item.textContent;
            const matches = careSymbols.filter(symbol => symbol.match.test(instruction));
            if (!matches.length) continue;
            const icons = document.createElement('span');
            icons.className = 'suntrybe-care-icons';
            icons.setAttribute('aria-hidden', 'true');
            icons.innerHTML = matches.map(symbol => '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" focusable="false">' + symbol.shape + (symbol.prohibit.test(instruction) ? '<path d="M2 2l20 20M22 2L2 22"/>' : '') + '</svg>').join('');
            const copy = document.createElement('span');
            copy.className = 'suntrybe-care-copy';
            copy.append(...Array.from(item.childNodes));
            item.classList.add('suntrybe-care-item');
            item.append(icons, copy);
            decorated = true;
          }
          if (decorated && piece.matches('ul, ol')) piece.classList.add('suntrybe-care-list');
        }
        const content = document.createDocumentFragment();
        groups.description.forEach(piece => content.append(piece));
        for (const key of ['details', 'care', 'size']) {
          if (!groups[key].length) continue;
          const row = document.createElement('details');
          row.className = 'suntrybe-product-info__row';
          const summary = document.createElement('summary');
          summary.textContent = this.dataset[key + 'Label'];
          const body = document.createElement('div');
          body.className = 'suntrybe-product-info__content';
          groups[key].forEach(piece => body.append(piece));
          row.append(summary, body);
          content.append(row);
        }
        const policies = this.querySelector(':scope > .suntrybe-product-info__row');
        if (policies) content.append(policies);
        source.replaceChildren(content);
        this.dataset.organized = 'true';
        const updateShippingBadge = () => {
          if (!this.dataset.shippingEstimate) return;
          const firstLine = this.dataset.shippingEstimate.split('\n')[0].trim();
          const compactTime = firstLine.replace(/^Estimated U\.S\. standard delivery:\s*/, '').replace(/, including production\.$/, '');
          let updated = false;
          for (const truck of document.querySelectorAll('.bi-truck')) {
            const label = truck.parentElement.nextElementSibling?.firstElementChild;
            if (!label || label.textContent.trim() !== 'See shipping estimate') continue;
            const heading = document.createElement('span');
            heading.textContent = this.dataset.deliveryLabel;
            const time = document.createElement('span');
            time.textContent = compactTime;
            const note = document.createElement('small');
            note.textContent = this.dataset.productionLabel;
            updated = true;
            label.classList.add('suntrybe-shipping-estimate-badge');
            label.replaceChildren(heading, document.createElement('br'), time, document.createElement('br'), note);
          }
          return updated;
        };
        const watchShippingBadge = () => {
          updateShippingBadge();
          const observer = new MutationObserver(updateShippingBadge);
          observer.observe(document.body, { childList: true, subtree: true });
          setTimeout(() => observer.disconnect(), 10000);
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchShippingBadge, { once: true });
        else watchShippingBadge();

      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
